export default __webpack_public_path__ + "static/media/icon2.b2644f09.svg";